import React from 'react';
type Bonus = {
  number: string;
  title: string;
  value: string;
  description: string;
  image: string;
  alt: string;
};
export const BonusStack = () => {
  const bonuses: Bonus[] = [{
    number: '1',
    title: 'Hormones in the Kitchen: 30 Complete Recipes',
    value: 'Real Value: $27',
    description: 'Thirty calming, hormone-friendly recipes built around real foods you already buy. Less decision fatigue. More nourishment. Each one quietly designed to support a different phase of your cycle — without taking over your kitchen.',
    image: 'https://cdn.magicpatterns.com/uploads/3F27J5zV3ke2zXMNnPpaTg/Bonus_1.png',
    alt: 'Hormones in the Kitchen — 30 Recipes ebook mockup'
  }, {
    number: '2',
    title: 'The Bible of Smart Supplementation',
    value: 'Real Value: $37',
    description: "A clear, science-grounded guide to the five supplements most worth your attention — and the dozens that aren't. So you can stop second-guessing every label and start choosing with confidence.",
    image: 'https://cdn.magicpatterns.com/uploads/8Wy4xEbUqrf3jXppB6omB4/MOCKUT_BONUS_2_The-Smart-Supplementation-Bible.png',
    alt: 'The Bible of Smart Supplementation ebook mockup'
  }, {
    number: '3',
    title: 'My Transformation Journal: Symptom and Progress Tracker',
    value: 'Real Value: $17',
    description: 'A gentle daily companion to track energy, sleep, mood, digestion, and cycle. Small, honest entries that quietly reveal the patterns your body has been waiting for you to notice.',
    image: 'https://cdn.magicpatterns.com/uploads/nWEPumsCxqdQZmujZuM5Ak/MOCKUT_BONUS_3_My-Transformation-Journal.png',
    alt: 'My Transformation Journal — Symptom & Progress Tracker mockup'
  }];
  return <section id="bonus-stack" className="w-full bg-light py-8 md:py-12 px-4 md:px-6 scroll-mt-16" data-id="element-13">
      <div className="max-w-[780px] mx-auto" data-id="element-14">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-15">
          Three Companion Guides — Included With Your Reset
        </h2>

        <div className="flex flex-col w-full" data-id="element-16">
          {bonuses.map((bonus, index) => <div key={index} className="w-full bg-white border-[2px] border-accent border-l-[6px] border-l-medium rounded-[16px] p-6 md:p-8 shadow-[0_4px_16px_rgba(149,125,173,0.15)] mb-6 box-border overflow-visible flex flex-col md:flex-row md:items-center gap-6 md:gap-8" data-id="element-17">
              {/* Image */}
              <div className="w-full md:w-[40%] flex-shrink-0" data-id="element-18">
                <img src={bonus.image} alt={bonus.alt} className="w-full h-auto rounded-[12px] shadow-[0_8px_24px_rgba(149,125,173,0.2)] object-cover" data-id="element-19" />
              </div>

              {/* Content */}
              <div className="flex flex-col flex-1 min-w-0" data-id="element-20">
                <div className="self-start bg-medium text-white font-lato font-bold text-[12px] tracking-[0.1em] py-[6px] px-[16px] rounded-[50px] inline-block mb-4" data-id="element-21">
                  BONUS {bonus.number}
                </div>

                <h3 className="font-playfair font-bold text-[22px] md:text-[26px] text-primary mb-2 leading-tight" data-id="element-22">
                  {bonus.title}
                </h3>

                <div className="self-start font-lato font-bold text-[13px] text-success bg-successBg py-[4px] px-[12px] rounded-[50px] inline-block mb-4" data-id="element-23">
                  {bonus.value}
                </div>

                <p className="font-lato text-[16px] text-secondary leading-[1.7] block visible m-0" style={{
              maxHeight: 'none',
              overflow: 'visible'
            }} data-id="element-24">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};